import { render, staticRenderFns } from "./global-search.vue?vue&type=template&id=cc07c166"
import script from "./global-search.vue?vue&type=script&lang=js"
export * from "./global-search.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports